// Dynamic environment configuration for production deployment
const getBackendUrl = () => {
  // Check if there's an explicit backend URL set
  const envBackendUrl = process.env.REACT_APP_BACKEND_URL;
  
  if (envBackendUrl && envBackendUrl.trim() !== '') {
    console.log('[Config] Using explicit REACT_APP_BACKEND_URL:', envBackendUrl);
    return envBackendUrl;
  }
  
  // Auto-detect based on current location
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // In development (localhost), we need to point to backend port
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Check if we're on the React dev server (port 3000)
    if (port === '3000' || port === '3001') {
      // Point to backend
      console.log('[Config] Development mode: Using backend port 8001');
      return `${protocol}//localhost:8001`;
    }
  }
  
  // In production (Emergent deployment), frontend and backend share same domain
  // Kubernetes ingress routes /api/* to backend automatically
  const productionUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`;
  console.log('[Config] Production mode: Using same domain:', productionUrl);
  return productionUrl;
};

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;

// Debug info
console.log('[Config] Final Backend URL:', BACKEND_URL);
console.log('[Config] Final API URL:', API_URL);
